import Routers from './navigation/Router'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { store } from '../src/store';
import { Provider } from 'react-redux';
import { saveState } from "../src/utility/browser-storage";
import { debounce } from "debounce";

import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

store.subscribe(
  debounce(() => {
    saveState(store.getState());
  }, 800)
);

function App() {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ToastContainer />
        <Routers />
      </I18nextProvider>
    </Provider>
  );
}
export default App;